module.exports = __webpack_public_path__ + "static/word-map-4ae13e7bac93fa1973916d72c766b167.svg";